// HM-310.r cluster 15 visual rework: AppLayout matched a
// docs/design-references/dashboard-v2-reference.html.
// 2 stati sidebar (240/64 con breakpoint 900px) - rimosso drawer mobile
// + burger. Logout ora vive in Sidebar.UserCard, NON in TopBar.

import type { ReactNode } from 'react';
import { Sidebar, type SidebarHotel, type SidebarItem, type SidebarUser } from './Sidebar';
import { TopBar } from './TopBar';
import { Toaster } from './components/Toast';
import { TooltipProvider } from './components/Tooltip';
import { useResponsiveSidebar } from './hooks/useResponsiveSidebar';

export interface AppLayoutProps {
  hotel: SidebarHotel;
  user: SidebarUser;
  sidebarItems: SidebarItem[];
  activeItemId: string;
  onItemSelect: (id: string) => void;
  onLogout?: () => void;
  notificationCount?: number;
  onSearchSubmit?: (q: string) => void;
  children: ReactNode;
}

export function AppLayout(props: AppLayoutProps) {
  const { mode, toggle } = useResponsiveSidebar();
  // HM-316.r cluster 15.4: sidebar e' position:fixed -> il main necessita
  // margin-left pari alla width della sidebar (240/64 px) per non finire
  // sotto. Topbar dentro main e' sticky top:0.
  const mainOffset = mode === 'collapsed' ? 'ml-16' : 'ml-60';

  return (
    <TooltipProvider delayDuration={150}>
      <div className="h-[var(--app-vh,100dvh)] overflow-hidden bg-bg-base text-text-primary">
        <Sidebar
          hotel={props.hotel}
          user={props.user}
          mode={mode}
          onToggle={toggle}
          items={props.sidebarItems}
          activeItemId={props.activeItemId}
          onItemSelect={props.onItemSelect}
          onLogout={props.onLogout}
        />

        <main className={`h-[var(--app-vh,100dvh)] flex flex-col min-h-0 min-w-0 ${mainOffset}`}>
          <TopBar
            notificationCount={props.notificationCount}
            onSearchSubmit={props.onSearchSubmit}
          />
          {/* HM-600 iPad UX: frame fisso al viewport, scorre solo il contenuto.
              topbar (sticky/shrink-0) + sidebar restano fissi. */}
          <div className="flex-1 min-h-0 overflow-y-auto">{props.children}</div>
        </main>

        <Toaster />
      </div>
    </TooltipProvider>
  );
}
